import type { ReactNode } from "react";

export function ActivityNotice({ children, loading = false, error = false, onRetry }: {
  children: ReactNode; loading?: boolean; error?: boolean; onRetry?: () => void;
}) {
  return <main id="main-content" className="activity-notice" dir="rtl" aria-busy={loading}>
    <div className="activity-notice__card" role={error ? "alert" : "status"}>
      <p>{children}</p>
      {onRetry && <button type="button" onClick={onRetry}>ניסיון נוסף</button>}
    </div>
  </main>;
}
